/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Restore_Error_TitleInputs */

const en_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Failed`)
};

const ar_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل الاستعادة`)
};

const de_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellung fehlgeschlagen`)
};

const es_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restauración fallida`)
};

const fr_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la récupération`)
};

const it_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristino non riuscito`)
};

const ja_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復元に失敗しました`)
};

const ko_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복원 실패`)
};

const pt_br_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na restauração`)
};

const ru_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановление не удалось`)
};

const th_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกู้คืนล้มเหลว`)
};

const tr_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri Yükleme Başarısız`)
};

const zh_cn_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复失败`)
};

const zh_tw_dialog_restore_error_title = /** @type {(inputs: Dialog_Restore_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還原失敗`)
};

/**
* | output |
* | --- |
* | "Restore Failed" |
*
* @param {Dialog_Restore_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_error_title = /** @type {((inputs?: Dialog_Restore_Error_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_Error_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_error_title(inputs)
	if (locale === "ar") return ar_dialog_restore_error_title(inputs)
	if (locale === "de") return de_dialog_restore_error_title(inputs)
	if (locale === "es") return es_dialog_restore_error_title(inputs)
	if (locale === "fr") return fr_dialog_restore_error_title(inputs)
	if (locale === "it") return it_dialog_restore_error_title(inputs)
	if (locale === "ja") return ja_dialog_restore_error_title(inputs)
	if (locale === "ko") return ko_dialog_restore_error_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_error_title(inputs)
	if (locale === "ru") return ru_dialog_restore_error_title(inputs)
	if (locale === "th") return th_dialog_restore_error_title(inputs)
	if (locale === "tr") return tr_dialog_restore_error_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_error_title(inputs)
	return zh_tw_dialog_restore_error_title(inputs)
});